/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';

// 查询
export const getTrafficLists = (data) => {
    return request({
        url: `/api-tms/driving/dispatchs`,
        method: 'post',
        data
    });
};

// 查询在途轨迹
export const getTrajectoryLists = (data) => {
    return request({
        url: `/api-tms/driving/queryztbdispatchtrace`,
        method: 'post',
        data
    });
};
// 查询站点详情
export const getSitedetails = (data) => {
    return request({
        url: `/api-tms/driving/sitedetail`,
        method: 'get',
        data
    });
};
export const pointList = (data) => {
    return request({
        url: `/api-tms/point/selectIndex`,
        method: 'post',
        data
    });
};
